
/**
 * Schema utilities specifici per la home page
 */

import { FALLBACK_METAL_PRICES } from '../server/config/ssr-config';

// FAQ Schema per domande comuni su oro e argento
export const createFAQSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Qual è il prezzo dell'oro oggi?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Il prezzo dell'oro viene aggiornato in tempo reale ogni 30 secondi su Gildy. Puoi vedere le quotazioni attuali per oro 24KT, 18KT e altre purità direttamente sulla nostra homepage."
        }
      },
      {
        "@type": "Question", 
        "name": "Come trovare il miglior compro oro vicino a me?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Su Gildy puoi cercare i migliori compro oro nella tua zona utilizzando la geolocalizzazione. Confronta prezzi, valutazioni e distanze per trovare l'offerta migliore."
        }
      },
      {
        "@type": "Question",
        "name": "Quanto vale il mio oro usato?",
        "acceptedAnswer": {
          "@type": "Answer", 
          "text": "Usa il calcolatore di valutazione gratuito di Gildy. Inserisci peso e purità del tuo oro per ottenere una stima immediata basata sui prezzi di mercato attuali."
        }
      },
      {
        "@type": "Question",
        "name": "I prezzi dell'argento sono aggiornati?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Sì, i prezzi dell'argento su Gildy vengono aggiornati ogni 30 secondi con le quotazioni di mercato più recenti per argento 999, 925 e 800."
        }
      }
    ]
  };
};

// Financial Service Schema per il servizio di valutazione
export const createFinancialServiceSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "FinancialProduct",
    "name": "Servizio Valutazione Metalli Preziosi",
    "description": "Servizio gratuito per la valutazione di oro e argento con prezzi aggiornati in tempo reale",
    "provider": {
      "@type": "Organization",
      "name": "Gildy",
      "url": "https://www.gildy.it"
    },
    "category": "Precious Metals Valuation",
    "feesAndCommissionsSpecification": "Servizio gratuito",
    "interestRate": "0%",
    "url": "https://www.gildy.it",
    "audience": {
      "@type": "Audience",
      "audienceType": "Consumers and Businesses",
      "geographicArea": {
        "@type": "Country",
        "name": "Italy"
      }
    }
  };
};

// Aggregate Rating Schema per statistiche dealer
export const createAggregateRatingSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "AggregateRating",
    "itemReviewed": {
      "@type": "Service",
      "name": "Rete Compro Oro Verificati Gildy",
      "description": "Rete di oltre 105 compro oro verificati in tutta Italia"
    },
    "ratingValue": "4.2",
    "bestRating": "5",
    "worstRating": "1", 
    "ratingCount": "1247",
    "reviewCount": "892"
  };
};

// Real-time Data Schema per prezzi live
export const createRealTimeDataSchema = (goldPrice: number, silverPrice: number) => {
  // Se i prezzi non sono disponibili o sono 0, mostra "ND" (Non Disponibile)
  const validGoldPrice = (goldPrice && goldPrice > 0) ? goldPrice : "ND";
  const validSilverPrice = (silverPrice && silverPrice > 0) ? silverPrice : "ND";

  return {
    "@context": "https://schema.org",
    "@type": "Dataset",
    "name": "Prezzi Metalli Preziosi in Tempo Reale",
    "description": "Dataset con prezzi aggiornati per oro e argento basati sui valori di mercato",
    "url": "https://www.gildy.it",
    "publisher": {
      "@type": "Organization", 
      "name": "Gildy",
      "url": "https://www.gildy.it"
    },
    "temporalCoverage": "Real-time",
    "spatialCoverage": {
      "@type": "Place",
      "name": "Italy"
    },
    "variableMeasured": [
      {
        "@type": "PropertyValue",
        "name": "Prezzo Oro 24KT",
        "value": validGoldPrice,
        "unitCode": "EUR",
        "unitText": "Euro per grammo"
      },
      {
        "@type": "PropertyValue", 
        "name": "Prezzo Argento 999",
        "value": validSilverPrice,
        "unitCode": "EUR",
        "unitText": "Euro per grammo"
      }
    ],
    "dateModified": new Date().toISOString()
  };
};

// Contact Point Schema per supporto
export const createContactPointSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "ContactPoint",
    "contactType": "Customer Service",
    "areaServed": "IT",
    "availableLanguage": "Italian",
    "url": "https://www.gildy.it/contatti"
  };
};
